import Lightbox from '~/app/elements/Lightbox';
import {
	addScreenModeListener,
	ScreenMode,
} from '~/app/utils/Screen';

/**
 * Инициализирует глобальные настройки лайтбокса
 */
function main(): void
{
	addScreenModeListener(
		( mode ) =>
		{
			Lightbox.toggleFullScreenMode(
				mode < ScreenMode.NOTEBOOK,
			);
		},
	);
}

/**
 * Module
 */
export {
	main as default,
};



// WEBPACK FOOTER //
// ./app/Common/Lightbox/index.ts